import type { ElementType, ReactNode } from 'react';
import styles from './SectionLabel.module.css';

export interface SectionLabelProps {
  children: ReactNode;
  /** Draws a hairline out to the right of the label. */
  rule?: boolean;
  /** The element to render. Use a heading level when the label really does head
      a section, so the page outline is correct; the default `div` is right when
      it is only a visual grouping. */
  as?: ElementType;
  className?: string;
}

/** A small uppercase label naming a group of content. */
export default function SectionLabel({
  children,
  rule = false,
  as: Tag = 'div',
  className,
}: SectionLabelProps) {
  const classes = [styles.label, rule ? styles.withRule : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return <Tag className={classes}>{children}</Tag>;
}
